import rxloop from '@rxloop/core';
import loading from '@rxloop/loading';
import devtools from '@rxloop/devtools';
import immer from '@rxloop/immer';


const plugins = [
  loading(),
  immer(),
];

if (process.env.NODE_ENV !== 'production') {
  plugins.push(
    devtools({
      blacklist: ['loading'],
    }),
  );
}

// 在一个应用创建一个全局唯一的 app
const store = rxloop({ plugins });

setTimeout(() => {
  store.start();
}, 0);

export default store;
